import { useAppConfig } from '@plato/app-core/hooks/use-app-config';

export function useAskPlatoEnabled(): boolean {
    const { enableAiChat } = useAppConfig();

    return enableAiChat;
}
